module.exports = __webpack_public_path__ + "01_glasses_brown.704b43a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/01_glasses_brown.png
// module id = iHqS
// module chunks = 0